import { useEffect, useState } from 'react'

export function useCabecalhoMinimizado() {
  const [isMinimizado, setIsMinimizado] = useState(false)

  useEffect(() => {
    const listener = () => {
      const cabecalhoMinimizado = window.scrollY >= 120 && window.document.body.offsetHeight - window.innerHeight > 550

      if (cabecalhoMinimizado && !isMinimizado) {
        setIsMinimizado(true)
      } else if (!cabecalhoMinimizado && isMinimizado) {
        setIsMinimizado(false)
      }
    }

    window.addEventListener('scroll', listener)

    return () => window.removeEventListener('scroll', listener)
  }, [isMinimizado])
  return isMinimizado
}
